export { default as InteractiveHotSpot } from './InteractiveHotSpot';
